module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
      return e[t];
    }.bind(null, o));
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 3);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("styled-components");
}, function (e, t) {
  e.exports = require("react-dom");
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(1),
      o = n.n(r),
      u = o.a.div.withConfig({
    displayName: "baseStyles__BaseModalBackground",
    componentId: "sc-12bzkqq-0"
  })(["display:flex;position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:30;background-color:rgba(0,0,0,0.5);align-items:center;justify-content:center;"]),
      c = n(0),
      a = n.n(c),
      l = a.a.createContext({}),
      i = l.Provider,
      f = l.Consumer;

  function d(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = [],
          r = !0,
          o = !1,
          u = void 0;

      try {
        for (var c, a = e[Symbol.iterator](); !(r = (c = a.next()).done) && (n.push(c.value), !t || n.length !== t); r = !0);
      } catch (e) {
        o = !0, u = e;
      } finally {
        try {
          r || null == a.return || a.return();
        } finally {
          if (o) throw u;
        }
      }

      return n;
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  function s(e) {
    var t = e.backgroundComponent,
        n = e.children,
        r = Object(c.useRef)(null),
        o = d(Object(c.useState)(null), 2),
        l = o[0],
        f = o[1],
        s = d(Object(c.useState)(u), 2),
        b = s[0],
        y = s[1];
    return Object(c.useEffect)(function () {
      t && y(t);
    }, [y, t]), Object(c.useEffect)(function () {
      f(r.current);
    }, [f, r]), a.a.createElement(i, {
      value: {
        modalNode: l,
        BackgroundComponent: b
      }
    }, n, a.a.createElement("div", {
      ref: r
    }));
  }

  var b = n(2),
      y = n.n(b);

  function p() {
    return (p = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }

      return e;
    }).apply(this, arguments);
  }

  function v(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = [],
          r = !0,
          o = !1,
          u = void 0;

      try {
        for (var c, a = e[Symbol.iterator](); !(r = (c = a.next()).done) && (n.push(c.value), !t || n.length !== t); r = !0);
      } catch (e) {
        o = !0, u = e;
      } finally {
        try {
          r || null == a.return || a.return();
        } finally {
          if (o) throw u;
        }
      }

      return n;
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  function m(e, t) {
    if (null == e) return {};

    var n,
        r,
        o = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          u = Object.keys(e);

      for (r = 0; r < u.length; r++) n = u[r], t.indexOf(n) >= 0 || (o[n] = e[n]);

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);

      for (r = 0; r < u.length; r++) n = u[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
    }

    return o;
  }

  function O(e) {
    var t,
        n = e.WrapperComponent,
        r = e.children,
        o = e.onBackgroundClick,
        u = e.onEscapeKeydown,
        l = e.allowScroll,
        i = e.beforeOpen,
        d = e.afterOpen,
        s = e.beforeClose,
        b = e.afterClose,
        O = e.backgroundProps,
        j = e.isOpen,
        g = m(e, ["WrapperComponent", "children", "onBackgroundClick", "onEscapeKeydown", "allowScroll", "beforeOpen", "afterOpen", "beforeClose", "afterClose", "backgroundProps", "isOpen"]),
        h = Object(c.useRef)(null),
        w = Object(c.useRef)(null),
        C = Object(c.useRef)(!1),
        k = v(Object(c.useState)(!1), 2),
        E = k[0],
        x = k[1],
        S = Object(c.useCallback)(u),
        _ = Object(c.useCallback)(o),
        P = Object(c.useCallback)(i),
        M = Object(c.useCallback)(d),
        B = Object(c.useCallback)(s),
        q = Object(c.useCallback)(b);

    function N(e) {
      h.current === e.target && _ && _(e);
    }

    return Object(c.useEffect)(function () {
      function e(e) {
        if (e) try {
          e().then(function () {
            return x(j);
          });
        } catch (e) {
          x(j);
        } else x(j);
      }

      E !== j && e(j ? P : B);
    }, [C, E, x, j, P, B]), Object(c.useEffect)(function () {
      E ? M && M() : C.current && q && q();
    }, [C, E, M, q]), Object(c.useEffect)(function () {
      function e(e) {
        "Escape" === e.key && S && S(e);
      }

      return E && document.addEventListener("keydown", e), function () {
        document.removeEventListener("keydown", e);
      };
    }, [E, S]), Object(c.useEffect)(function () {
      return E && !l && (w.current = document.body.style.overflow, document.body.style.overflow = "hidden"), function () {
        l || (document.body.style.overflow = w.current || "");
      };
    }, [E, l]), Object(c.useEffect)(function () {
      C.current = !0;
    }, [C]), t = n ? a.a.createElement(n, g, r) : r, a.a.createElement(f, null, function (e) {
      var n = e.modalNode,
          r = e.BackgroundComponent;
      return n && r && E ? y.a.createPortal(a.a.createElement(r, p({}, O, {
        onClick: N,
        ref: h
      }), t), n) : null;
    });
  }

  O.styled = function () {
    var e = o.a.div.withConfig({
      displayName: "Modal__styles",
      componentId: "sc-1q9xwty-0"
    })(["", ""], r.css.apply(void 0, arguments)) || o.a.div.withConfig({
      displayName: "Modal__styles",
      componentId: "sc-1q9xwty-1"
    })([""]);
    return function (t) {
      return a.a.createElement(O, p({
        WrapperComponent: e
      }, t));
    };
  }, O.defaultProps = {
    backgroundProps: {}
  };
  var j = O;
  n.d(t, "ModalProvider", function () {
    return s;
  }), n.d(t, "BaseModalBackground", function () {
    return u;
  });
  t.default = j;
}]);